// extracted by mini-css-extract-plugin
module.exports = {"starcSmallBodyOverride":"az_MIb","viewAllLabel":"az_NIb","specCard":"az_OIb","viewAllLink":"az_PIb"};